var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","md":"12","sm":"12"}},[_c('session-title',{staticClass:"pt-8 px-10 pb-5",attrs:{"title":"Fotos"}}),_c('photos-cards')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }